import React from 'react';
import Icon from '../../Components/Icons/Icon';
import menu from '../menu';
import {Link, useLocation} from 'react-router-dom';
import { useSession } from '../../Components/Session';
import { useDialogues } from '../../Components/Dialogues';
import Button from '../../Components/Button/Button';
import { levels } from '../../Data/Admin';
import { classNames } from '../../Services/helpers';
import { Badge } from '@/Components/Primitives';

export default () => {
    const path = useLocation().pathname;
    const {notificationBadge, isRoleSufficient, isAdminSwitched, adminSwitchBack, isAdmin} = useSession();

    return <div className="grow-0 pt-2 pr-2 bg-blue-50 max-h-screen min-h-screen print:hidden">
        <nav className="mt-1 fixed mx-auto h-full overflow-y-auto no-scrollbar">
            <ul className="m-0 list-none">
                    {menu.items.map((item) => {
                        if (item.adminOnly && !isAdmin(levels.READ_ONLY)) {
                            return null;
                        }

                        if (item.role && !isRoleSufficient(item.role)) {
                            return <LockedTab key={item.title} title={item.title} icon={item.icon} role={item.role} />;
                        }
                        return <Tab key={item.title}
                                    item={item}
                                    subitems={item.subitems}
                                    path={path}
                                    notificationBadge={(item.notificationBadge && notificationBadge) ? notificationBadge : false}
                                />
                    })}
            </ul>
            {isAdminSwitched && <Button theme="danger" label="Switch back" className="w-full" onClick={adminSwitchBack} />}
        </nav>
        <div className="w-[200px]">&nbsp;</div>
    </div>;
}

const selectTabPath = (item, hasFeature) => {
    return item.path ?? item.subitems.find((subitem) => !subitem.feature || hasFeature(subitem.feature))?.path;
}

const Tab = ({ item, path, subitems, notificationBadge }) => {
    const {hasFeature, isAdmin} = useSession();
    const active = path.match(item.match);

    return <li className={classNames(
        'relative pl-3 pr-10 my-1 transition-all duration-300',
        active ? 'bg-white rounded-xl border-brand border-l-4 text-slate-900' : 'bg-transparent border-transparent border-l-0 text-slate-700'
    )}>
        <Link to={selectTabPath(item, hasFeature)}
            className={classNames(
                'flex h-12 cursor-pointer items-center',
                (active && !subitems) && 'font-bold',
                'hover:text-brand'
            )}
        >
            <span className="mr-4">
                <Icon icon={item.icon}
                    theme={active ? 'solid' : 'light'}
                    className={active ? 'fill-brand' : 'fill-slate-700'}
                    size="2x"
                    inline
                />
            </span>
            <span className="w-full">
                {item.title}
                {notificationBadge && <Badge theme="danger" title={notificationBadge} className="float-right" />}
            </span>
        </Link>

        {subitems && <ul className="relative m-0 list-none p-0 pb-1">
            {subitems.map((item) => {
                if (item.adminOnly && !isAdmin(levels.READ_ONLY)) {
                    return null;
                }

                return <Subtab key={item.title}
                            title={item.title}
                            path={item.path}
                            active={path.match(item.match)}
                            feature={item.feature}
                            role={item.role}
                        />
            })}
        </ul>}
    </li>
}

const LockedTab = ({ title, icon, role }) => {
    const {roleInsufficient} = useDialogues();

    return <li className={'relative pl-3 pr-10 my-1 text-muted fill-muted'} onClick={() => roleInsufficient(role)}>
        <div className={'flex h-12 cursor-pointer items-center'}>
            <span className="mr-4">
                <Icon icon={icon} theme="light" inline size="2x" />
            </span>
            <span className="w-full">
                {title}
            </span>
        </div>
    </li>
}

const Subtab = ({ title, active, path, feature, role }) => {
    const {hasFeature, isRoleSufficient} = useSession();
    const {featureUnavailable, roleInsufficient} = useDialogues();

    let element = <Link to={path} className="flex h-6 pl-10 cursor-pointer items-center">{title}</Link>;

    if ((feature && !hasFeature(feature)) || (role && !isRoleSufficient(role))) {
        element = <span className="flex h-6 pl-10 cursor-pointer items-center text-muted fill-muted"
            onClick={() => (feature && !hasFeature(feature)) ? featureUnavailable(feature) : roleInsufficient(role)}
        >
            {title} <Icon icon="Lock" className="ml-2" inline />
        </span>;
    }

    return <li className={classNames(
        'relative py-1 mb-2',
        active && 'font-bold text-brand underline underline-offset-8 decoration-brand',
        'hover:text-brand'
    )}>
        {element}
    </li>
}
